import { SESSION_EXP_TIME } from 'consts/consts';
import { LS } from 'consts/localStorage';
import { readFromLs, writeToLs } from 'helpers/helpers';
import { ENGT_CHAT } from 'js/bot.model';
import { setSessionExpiredMsg } from '../index';
import { appendStatusDivider } from './conversation';

let sessionTimeoutId = null;

const setTabCounterCount = () => {
	const tabCounter = parseInt(readFromLs(LS().TAB_COUNTER) ?? 0) + 1;
	writeToLs(LS().TAB_COUNTER, tabCounter);
};

export const setSession = () => {
	setTabCounterCount();

	if (ENGT_CHAT.get('config.launch_flow')) {
		return;
	}

	const messageList = JSON.parse(readFromLs(LS().PREV_MESSAGES));

	if (Array.isArray(messageList) && messageList.length) {
		const lastMessageTimestamp = messageList[messageList.length - 1]?.timestamp;
		const difference = new Date() - new Date(lastMessageTimestamp);
		ENGT_CHAT.set('config.sessionExpired', false);
		ENGT_CHAT.set('triggerSessionExpired', false);
		if (difference >= SESSION_EXP_TIME) {
			setSessionExpiredMsg();
		} else {
			if (readFromLs(LS().GOT_UID) === 'false') {
				if (!ENGT_CHAT.get('startConvoAdded')) {
					appendStatusDivider();
					const closeChatDivider = Array.from(
						document.querySelectorAll('.engt-status-divider-wrapper')
					).pop();
					closeChatDivider?.scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'nearest' });
					ENGT_CHAT.get('renderStartConversation')();
					writeToLs(
						LS().TAB_MESSAGES,
						JSON.stringify({ action: 'enable_session_timeout', tabId: ENGT_CHAT.get('socketId') })
					);
					ENGT_CHAT.set('startConvoAdded', true);
					ENGT_CHAT.set('triggerSessionExpired', true);
					ENGT_CHAT.set('firstTime', true);
				}
			} else {
				writeToLs(LS().GOT_UID, 'true');
			}
			clearSessionTimeoutId();
			setSessionTimeoutId(SESSION_EXP_TIME - difference);
		}
	}
};

export const clearSessionTimeoutId = () => {
	if (sessionTimeoutId) {
		clearTimeout(sessionTimeoutId);
		sessionTimeoutId = null;
		ENGT_CHAT.get('updatePreviewMessage')();
	}
};

export const setSessionTimeoutId = (t) => {
	const time = t || SESSION_EXP_TIME;

	sessionTimeoutId = setTimeout(() => {
		setSessionExpiredMsg();
	}, time);
};

export const handleSessionTimer = () => {
	if (ENGT_CHAT.get('config.isOldMessage') || ENGT_CHAT.get('config.launch_flow_copy')) {
		return;
	}
	clearSessionTimeoutId();
	setSessionTimeoutId();
};
